import React, { useEffect, useState } from 'react'
import { DigitalVaultReportsView } from '../../views';
import { CompanyService, LocalStorageService } from '../../../services';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const DigitalVaultReportsAction = (props) => {
    const {
        toggleCompletedRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting,
        t
    } = props;

    const history = useHistory();
    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const companyService = new CompanyService(url);
    const token = localStorageService.getLocalStorageItem("token").idToken;
    const { state } = useLocation();

    const [isLoading, setIsLoading] = useState(true);
    const [isUser, setIsUser] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompanyId, setSelectedCompanyId] = useState(0);
    const [selectedDocumentId, setSelectedDocumentId] = useState(null);

    const loadCompanies = async () => {
        setIsLoading(true);

        try {
            const response = await companyService.getUsersCompanies(token)
            if (response.statusCode == 200 && response.data) {
                let data = response.data.map(c => c.company)
                data.sort((a, b) => a.companyName.localeCompare(b.companyName));
                data = [{ id: 0, companyName: t("digitalVaultReportsAction.all.companies") }, ...data];
                setCompanies(data);
            } else {
                throw new Error(response.message || t("digitalVaultReportsAction.errors.general.companies"))
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    useEffect(() => {
        loadCompanies();
        const userRoles = localStorageService.getLocalStorageItem("user").userMetaData.userRoles
        const { role } = userRoles.find(item => item.role.groupName === "hibouDigitalVault" && item.role.key !== "roleHibouDigitalContractNotAccess")
        if (!role) {
            history.replace("/")
        } else if (role.key !== "roleHibouDigitalVaultSuscriber") {
            setIsUser(true);
        }

        if (state) {
            setSelectedCompanyId(state.selectedCompanyId);
            setSelectedDocumentId(state.documentId);
        }
    }, [])

    return (
        <DigitalVaultReportsView
            isLoading={isLoading}
            isUser={isUser}
            companies={companies}
            selectedCompanyId={selectedCompanyId}
            setSelectedCompanyId={setSelectedCompanyId}

            selectedDocumentId={selectedDocumentId}
            setSelectedDocumentId={setSelectedDocumentId}

            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultReportsAction));